import { Alert, Text } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";

export function ChangeReportConfigAlert() {
  return (
    <Alert
      maw="60rem"
      variant="light"
      icon={<IconAlertTriangle />}
      title="Es gibt bereits Berichte, welche diese Vorlage verwenden"
      color="zli-orange"
    >
      <Text>
        Änderungen an dieser Vorlage können zu Datenverlust in den Berichten führen. Bitte löschen Sie Inhalte nur mit Bedacht. Alternativ
        können Sie eine Kopie erstellen und diese bearbeiten.
      </Text>
    </Alert>
  );
}
